"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsSQLite = void 0;
class UtilsSQLite {
    constructor() {
        this.pathDB = "./DataStorage";
        this.Path = null;
        this.NodeFs = null;
        this.SQLite3 = null;
        this.Path = require("path");
        this.NodeFs = require("fs");
        this.SQLite3 = require("sqlite3");
    }
    async connection(dbName, readOnly) {
        const flags = readOnly
            ? this.SQLite3.OPEN_READONLY
            : this.SQLite3.OPEN_CREATE | this.SQLite3.OPEN_READWRITE;
        // get the path for the database
        try {
            const dbPath = await this.getDBPath(dbName);
            const dbOpen = new this.SQLite3.Database(dbPath, flags);
            return Promise.resolve(dbOpen);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async getWritableDatabase(dbName) {
        const db = await this.connection(dbName, false /*,secret*/);
        return db;
    }
    async getReadableDatabase(dbName) {
        const db = await this.connection(dbName, true /*,secret*/);
        return db;
    }
    isFileExists(dbName) {
        const dbFolder = this.pathDB;
        const path = this.Path.join(dbFolder, dbName);
        let ret = false;
        try {
            if (this.NodeFs.existsSync(path)) {
                ret = true;
            }
            return Promise.resolve(ret);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async getDBPath(dbName) {
        let retPath = null;
        const dbFolder = this.pathDB;
        retPath = this.Path.join(dbFolder, dbName);
        try {
            if (!this.NodeFs.existsSync(dbFolder)) {
                await this.mkdirSyncRecursive(dbFolder);
            }
            return Promise.resolve(retPath);
        }
        catch (err) {
            return Promise.reject(err);
        }
    }
    async mkdirSyncRecursive(directory) {
        const path = directory.replace(/\/$/, "").split("/");
        for (let i = 1; i <= path.length; i++) {
            const segment = path.slice(0, i).join("/");
            segment.length > 0 && !this.NodeFs.existsSync(segment)
                ? this.NodeFs.mkdirSync(segment)
                : null;
        }
        return;
    }
}
exports.UtilsSQLite = UtilsSQLite;
//# sourceMappingURL=UtilsSQLite.js.map